import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import AddTask from './AddTask';
import AddUser from './AddUser';

const AddProject = ({ isOpen, setIsOpen }) => {
    const [billingMethod, setBillingMethod] = useState('');
    const [projectCost, setProjectCost] = useState('');
    const [ratePerHour, setRatePerHour] = useState('');
    const [selectedTasks, setSelectedTasks] = useState([]);
    const [selectedUser, setSelectedUser] = useState([]);
    const [isAddTaskModalOpen, SetAddTaskModalOpen] = useState(false);
    const [isAddUserModalOpen, SetAddUserModalOpen] = useState(false);
    const [taskRate, setTaskRate] = useState('');
    const [userRate, setUserRate] = useState('');

    const customerOptions = [
        { value: 'customer1', label: 'Customer 1' },
        { value: 'customer2', label: 'Customer 2' },
    ];

    const taskOptions = [
        { value: 'task1', label: 'Task 1' },
        { value: 'task2', label: 'Task 2' },
    ];

    const userOptions = [
        { value: 'user1', label: 'User 1' },
        { value: 'user2', label: 'User 2' },
    ];

    const billingOptions = [
        { value: 'fixedCost', label: 'Fixed Cost for Project' },
        { value: 'projectHours', label: 'Based on Project Hours' },
        { value: 'taskHours', label: 'Based on Task Hours' },
        { value: 'staffHours', label: 'Based on Staff Hours' },
    ];

    if (!isOpen) return null;

    return (
        <>
            <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
                <div
                    className="custom-modal-content"
                    onClick={(e) => e.stopPropagation()} // Prevent closing on content click
                >
                    <h2 className="oms-modal-title">Add Project</h2>
                    <form className="oms-modal-form">
                        {/* Customer Selection */}
                        <div className="oms-form-group">
                            <label htmlFor="customer" className="oms-form-label">
                                Customer
                            </label>
                            <Select options={customerOptions} placeholder="Select or Add Customer" />
                            <Link to='/add-customer'>
                            <button type="button" className="oms-add-button">
                                Add New Customer
                            </button>
                            </Link>
                        </div>

                        {/* Project Name */}
                        <div className="oms-form-group">
                            <label htmlFor="projectName" className="oms-form-label">
                                Project Name
                            </label>
                            <input
                                type="text"
                                id="projectName"
                                placeholder="Enter project name"
                            />
                        </div>

                        {/* Billing Method */}
                        <div className="oms-form-group">
                            <label htmlFor="billingMethod" className="oms-form-label">
                                Billing Method
                            </label>
                            <Select
                                options={billingOptions}
                                placeholder="Select Billing Method"
                                onChange={(option) => setBillingMethod(option.value)}
                            />
                        </div>

                        {/* Billing Details */}
                        {billingMethod === 'fixedCost' && (
                            <div className="oms-form-group">
                                <label htmlFor="fixedCost" className="oms-form-label">
                                    Project Cost [INR]
                                </label>
                                <input
                                    type="number"
                                    id="fixedCost"
                                    placeholder="Enter project cost"
                                    value={projectCost}
                                    onChange={(e) => setProjectCost(e.target.value)}
                                />
                            </div>
                        )}
                        {billingMethod === 'projectHours' && (
                            <div className="oms-form-group">
                                <label htmlFor="ratePerHour" className="oms-form-label">
                                    Rate/Hour [INR]
                                </label>
                                <input
                                    type="number"
                                    id="ratePerHour"
                                    placeholder="Enter rate per hour"
                                    value={ratePerHour}
                                    onChange={(e) => setRatePerHour(e.target.value)}
                                />
                            </div>
                        )}

                        {/* Description */}
                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Description
                            </label>
                            <textarea
                                id="description"
                                placeholder="Enter project description"
                                rows="4"
                            />
                        </div>

                        {/* Task */}
                        <div className="oms-form-group">
                            <label htmlFor="task" className="oms-form-label">
                                Task
                            </label>
                            <div className="oms-flex-group">
                                <Select
                                    options={taskOptions}
                                    placeholder="Select task"
                                    isMulti
                                    onChange={(selected) => setSelectedTasks(selected)}
                                />
                                <button type="button" className="oms-add-button" onClick={() => SetAddTaskModalOpen(true)}>
                                    Add Task
                                </button>
                            </div>
                        </div>

                        {/* Task */}
                        <div className="oms-form-group">
                            <label htmlFor="task" className="oms-form-label">
                                User
                            </label>
                            <div className="oms-flex-group">
                                <Select
                                    options={userOptions}
                                    placeholder="Select user"
                                    isMulti
                                    onChange={(selected) => setSelectedUser(selected)}
                                />
                                <button type="button" className="oms-add-button" onClick={() => SetAddUserModalOpen(true)}>
                                    Add User
                                </button>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="oms-form-actions">
                            <button type="button" onClick={() => setIsOpen(false)}>
                                Cancel
                            </button>
                            <button type="submit">Submit</button>
                        </div>
                    </form>
                </div>
            </div>


            <AddTask
                isOpen={isAddTaskModalOpen}
                setIsOpen={SetAddTaskModalOpen}
                showTaskRate={billingMethod === 'taskHours'}
                setTaskRate={setTaskRate}
                taskRate={taskRate} />
            <AddUser
                isOpen={isAddUserModalOpen}
                setIsOpen={SetAddUserModalOpen}
                showUserRate={billingMethod === 'staffHours'}
                setUserRate={setUserRate}
                userRate={userRate}
            />
        </>
    );
};

export default AddProject;